import { normalize } from 'normalizr'
import { vehicleSchema } from 'auth/nAmSchemas'
import { getCreditCardNumberPreview, getPadNumberPreview } from 'shared/utils'
import { PAYMENT_METHOD_TYPE_CREDIT_CARD } from 'auth/constants'

export const vehiclesEntityToArray = fieldMap => {
    const vehicles = normalize(fieldMap?.extended?.fieldMap?.vehicles?.fieldList || {}, [vehicleSchema()])
    const vehicleEntities = vehicles?.entities?.vehicles
    if (vehicleEntities) {
        const vehicleEntitiesArray = Object.keys(vehicleEntities)
        return vehicleEntitiesArray.map(v => vehicleEntities[v])
    }

    return null
}

export const paymentMethodOptionLabel = method => {
    if (method.paymentMethodType === PAYMENT_METHOD_TYPE_CREDIT_CARD) {
        const { nickName, cardLast4, expDate } = method
        return getCreditCardNumberPreview({ nickName, cardLast4, expDate })
    } else {
        const { achAccountNumber } = method
        return getPadNumberPreview({ achAccountNumber })
    }
}
